import { useWeb3ModalProvider } from '@web3modal/ethers/react'
import { BrowserProvider } from 'ethers'
import { getCsrfToken } from 'next-auth/react'
import { SiweMessage } from 'siwe'

export const useSignature = () => {
    const { walletProvider } = useWeb3ModalProvider()

    const signMessage = async (): Promise<{ signature: string; message: string } | undefined> => {
        if (typeof walletProvider === 'undefined') return
        try {
            const provider = new BrowserProvider(walletProvider)
            const signer = await provider.getSigner()

            const nonce = await getCsrfToken()

            if (!nonce) throw new Error('Failed to get nonce!')

            const siwe = new SiweMessage({
                domain: window.location.host,
                uri: window.location.origin,
                address: signer.address,
                statement: 'Sign in to Artoys',
                nonce,
                version: '1',
                chainId: process.env.NEXT_PUBLIC_CONTRACT_CHAIN_ID,
            })

            const message = siwe.prepareMessage()
            const signature = await signer.signMessage(message)

            return { signature, message }
        } catch (error) {
            console.warn('error', error)
        }
    }

    return { signMessage }
}
